import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import AddNewGateForm from "./AddNewGateForm";

function AddNewGate({ getAllGates, companyId }) {
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <div className="Down__Btn">
        <Button
          onClick={() => setShowModal(true)}
          iconPos="right"
          label={"Add New Gate"}
          className="Btn__Dark"
        />
      </div>
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <AddNewGateForm
          onCloseModal={onCloseModal}
          getAllGates={getAllGates}
          companyId={companyId}
        />
      </Dialog>
    </>
  );
}

export default AddNewGate;
